import React, { ReactNode } from 'react'
import { Accordion as MUIAccordion } from '@mui/material'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface AccordionProps {
  title: string
  children?: ReactNode
}

export const Accordion: React.FC<AccordionProps> = ({ children, title }) => {
  return (
    <div style={{ width: '100%' }}>
      <MUIAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='panel1a-header'
          sx={{ backgroundColor: '#e2e8f0' }}
        >
          <Typography sx={(theme) => ({ fontSize: theme.typography.pxToRem(15), fontWeight: 'bold' })}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>{children}</Typography>
        </AccordionDetails>
      </MUIAccordion>
    </div>
  )
}
